var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.513 0.0476251C7.39957 0.00515116 7.27754 -0.00921829 7.15734 0.00574592C7.03715 0.0207101 6.92237 0.0645627 6.82281 0.133553C6.72326 0.202544 6.64189 0.29462 6.58568 0.401907C6.52946 0.509195 6.50006 0.628502 6.5 0.749625V12.8766C5.80703 12.3218 4.94918 12.0133 4.06156 11.9996C3.17395 11.9859 2.30701 12.2679 1.59729 12.8012C0.887565 13.3344 0.375388 14.0886 0.141425 14.9449C-0.0925386 15.8012 -0.0349936 16.7111 0.304997 17.5311C0.644987 18.3511 1.2481 19.0348 2.01935 19.4743C2.79061 19.9139 3.68617 20.0844 4.56498 19.959C5.4438 19.8336 6.25594 19.4195 6.87349 18.7818C7.49104 18.144 7.87891 17.319 7.976 16.4366C7.99185 16.3756 7.99991 16.3127 8 16.2496V6.83162L14.987 9.45162C15.1004 9.4941 15.2225 9.50847 15.3427 9.4935C15.4629 9.47854 15.5776 9.43469 15.6772 9.3657C15.7768 9.29671 15.8581 9.20463 15.9143 9.09734C15.9705 8.99006 15.9999 8.87075 16 8.74963V5.48263C16.0002 4.82087 15.7983 4.17482 15.4215 3.63086C15.0446 3.0869 14.5106 2.67095 13.891 2.43863L7.513 0.0476251Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note.4ea87ccd6d5864805154e722c7225609.svg";